import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { PRIVATE } from 'router/constants/routes';

import { closeModal } from 'store/modals/actions';
import { selectCurrentUser } from 'store/user/selectors';

import { accountTabs, TABS } from 'constants/account';

import { Text } from 'components/library';

import { UserStore } from 'types/store/userStore';

import DefaultUserPic from 'assets/img/default-avatar.svg';

import ProfileTab from './components/ProfileTab';
import SettingsTab from './components/SettingsTab';
import SubscriptionsTab from './components/SubscriptionsTab';
import Tabs from './components/Tabs';

import * as S from './styled';

const AccountSettings = () => {
    const navigate = useNavigate();
    const params: { tabId?: string } = useParams();
    const dispatch = useDispatch();

    const currentUser: UserStore = useSelector(selectCurrentUser);

    const tabId = params.tabId;
    const currentTabId = tabId || accountTabs.Profile;

    const handleChangeTab = (tabId: string) => {
        const path = `${PRIVATE.ACCOUNT_DEFAULT.path}/${tabId}`;

        navigate(path);
    };

    useEffect(() => {
        // this action need for the case when user click "back" btn in browser
        dispatch(closeModal());
    }, [currentTabId]);

    const getCurrentTab = (currentTab: string) => {
        switch (currentTab) {
            case accountTabs.Subscription:
                return <SubscriptionsTab />;

            case accountTabs.Settings:
                return <SettingsTab />;

            default:
                return <ProfileTab />;
        }
    };

    return (
        <>
            <S.Container dataLocator="account-settings-page">
                <S.AvatarWrapper $paddingTop={24} $paddingBottom={16} $paddingX={16}>
                    <DefaultUserPic />
                    <Text type="h5">{`${currentUser?.name ?? ''} ${currentUser?.last_name ?? ''}`}</Text>
                </S.AvatarWrapper>
                <S.ContentWrapper>
                    <Tabs tabs={TABS} currentTab={currentTabId} onChange={handleChangeTab} />
                </S.ContentWrapper>
            </S.Container>
            <S.ContentWrapper $paddingX={16}>{getCurrentTab(currentTabId)}</S.ContentWrapper>
        </>
    );
};

export default AccountSettings;
